import React from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Button from '../Button'
import Spinner from '../Spinner'
import styles from '../../pages/dashboard/dashboard.module.scss'
import { images } from '../../assets'
import axios from 'axios'

const FormikForm = (props) => {
  const {
    fieldInfos,
    initialValue,
    initialTouched,
    onSubmit,
    submitBtnLabel,
    submitBtnClass,
    submitBtnClassDisabled,
    formButtonRow,
    additionalBottomComponent,
    onAdditionalButtonClicked,
    showForgotPassword,
    centered,
    loading,
    successMessage,
    validateOnChange,
    submitButtonKey,
    tpBG,
    isThirdParty,
  } = props

  const getValidationSchema = (fieldInfos) => {
    let schema = {}
    const phoneRegExp =
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
    fieldInfos?.forEach((fieldInfo) => {
      switch (fieldInfo.type) {
        case 'text':
          console.log('fieldInfo.slug', fieldInfo.slug)

          if (fieldInfo.slug === 'healthInsuranceCardNumber') {
            console.log('healthInsuranceCardNumber matched')
            schema[fieldInfo.slug] = Yup.string().test(
              // it runs even if previous validation failed!
              'healthInsuranceCardNumber',
              'health card validation failed',
              // it triggers on every onBlur
              (healthCardNumber, { createError }) => {
                console.log(
                  'healthInsuranceCardNumber healthCardNumber text ',
                  healthCardNumber,
                )
                return new Promise((resolve, reject) => {
                  if (healthCardNumber) {
                    const data = {
                      hn: String(healthCardNumber) || '',
                      state: 'Ontario',
                    }
                    console.log('email registration runs')
                    axios({
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                      },
                      url: `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL}/healthCardValidationJs`,
                      mode: 'cors',
                      data: JSON.stringify(data),
                    })
                      .then((res) => {
                        console.log('healthCardValidation res ', res?.data)
                        if (
                          res?.data?.validation === 'true' ||
                          res?.data?.validation === true
                        ) {
                          console.log('healthCardValidation true')
                          resolve(true)
                        } else if (res?.data?.message) {
                          console.log(
                            'healthCardValidation res?.data?.message',
                            res?.data?.message,
                          )
                          // resolve(Yup.ValidationError.formatError(res?.data?.message))
                          resolve(createError({ message: res?.data?.message }))
                        } else {
                          console.log('healthCardValidation false')
                          reject(false)
                        }
                      })
                      .catch((error) => {
                        console.log('healthCardValidation error ', error)
                        reject(false)
                      })
                  } else {
                    reject(false)
                  }
                })
              },
            )
          } else {
            schema[fieldInfo.slug] = Yup.string()
          }
          break
        case 'textarea':
        case 'password':
        case 'date':
          schema[fieldInfo.slug] = Yup.string()
          break
        case 'dropdown':
          schema[fieldInfo.slug] = Yup.object().shape({
            label: Yup.string().required(),
            value: Yup.string()
              .matches(/^(?!-1\b)/i, `${fieldInfo.label} is required`)
              .required(),
          })
          break
        case 'number':
          schema[fieldInfo.slug] = Yup.number()
          break
        case 'image':
          schema[fieldInfo.slug] = Yup.object()
            .typeError(`${fieldInfo.label} is required`)
            .required(`${fieldInfo.label} is required`)
          break
        case 'checklist':
        case 'vertical_check_list':
          schema[fieldInfo.slug] = Yup.array().min(1)
          break
        case 'horizontal_check_box':
          schema[fieldInfo.slug] = Yup.string()
          break
        case 'input_image':
          schema[fieldInfo.slug] = Yup.object().shape({
            text: Yup.string().required(),
            images: Yup.array().notRequired(),
          })
          break
        case 'phone':
          schema[fieldInfo.slug] = Yup.string()
            .matches(phoneRegExp, 'Phone number is not valid')
            .min(11, 'Phone number is not valid')
          break
        default:
          break
      }
      fieldInfo.validations.forEach((validation) => {
        switch (typeof validation) {
          case 'object':
            try {
              Object.keys(validation).forEach((key) => {
                switch (key) {
                  case 'matchWith':
                    schema[fieldInfo.slug] = schema[fieldInfo.slug].oneOf(
                      [Yup.ref(validation['matchWith']), null],
                      'Passwords must match',
                    )
                    break
                  case 'regex':
                    const [regex, errorMsg] = validation['regex']
                    schema[fieldInfo.slug] = schema[fieldInfo.slug].matches(
                      regex,
                      errorMsg,
                    )
                    break
                }
              })
            } catch {
              console.log('validation-object parse error')
            }
            break
          case 'string':
            switch (validation) {
              case 'required':
                schema[fieldInfo.slug] = schema[fieldInfo.slug].required(
                  fieldInfo.label + ' is required',
                )
                break
              case 'not-required':
                schema[fieldInfo.slug] = schema[fieldInfo.slug].notRequired()
                break
              case 'email':
                schema[fieldInfo.slug] =
                  schema[fieldInfo.slug].email('Invalid email')
                break
              case 'password':
                schema[fieldInfo.slug] = schema[fieldInfo.slug]
                  .min(8, 'Must be at least 8 characters')
                  .matches(/.*\d.*/i, 'Must have at least one digit (from 0-9)')
                  .matches(
                    /.*[A-Z].*/i,
                    'Must have at least one letter from A-Z',
                  )
                break
            }
            break
        }
      })
    })
    return schema
  }
  const ShowHealthCardButton = () => (
    <div>
      Doesn't have an OHIP Card?{' '}
      <span className={styles.continueText} onClick={onAdditionalButtonClicked}>
        Continue{' '}
        <img src={images.continueArrow} className={styles.continueArrowIcon} />
      </span>
    </div>
  )

  const showForgotPasswordButton = () => (
    <div>
      <span className={styles.continueText} onClick={onAdditionalButtonClicked}>
        Forgot Password?{' '}
      </span>
    </div>
  )

  const formikProps =
    initialValue && initialTouched
      ? useFormik({
          initialValues: initialValue || {},
          initialTouched: initialTouched || {},
          validationSchema: Yup.object().shape(getValidationSchema(fieldInfos)),
          onSubmit: onSubmit,
          validateOnBlur: true,
          validateOnChange: validateOnChange !== false,
        })
      : null
  console.log('formikProps', formikProps)
  console.log('additionalBottomComponent', additionalBottomComponent)
  let additionalStyle = ''
  if (!additionalBottomComponent || !showForgotPassword) {
    additionalStyle = centered
      ? ''
      : showForgotPassword || additionalBottomComponent
      ? ' justify-content-between'
      : ' justify-content-end'
  }
  console.log('additionalStyle ', additionalStyle)
  const disabled =
    loading /* || Object.keys(formikProps?.touched || {}).length === 0 */ ||
    !formikProps?.isValid
  return formikProps ? (
    <form onSubmit={formikProps.handleSubmit} className="w-50">
      {props.renderFormFields(fieldInfos, formikProps)}
      {<div>{successMessage}</div>}
      <div className={formButtonRow + additionalStyle || 'm-auto my-2 mt-4'}>
        {!!additionalBottomComponent && ShowHealthCardButton()}
        <Button
          id={submitButtonKey}
          type="submit"
          onClick={() => {
            formikProps.handleSubmit()
          }}
          className={
            disabled
              ? submitBtnClassDisabled
              : [`${isThirdParty ? tpBG : ''} ${submitBtnClass}`]
          }
          disabled={disabled}
        >
          {loading ? <Spinner color="white" isLoading /> : submitBtnLabel}
        </Button>
        {!!showForgotPassword && showForgotPasswordButton()}
      </div>
    </form>
  ) : (
    <div></div>
  )
}

export default FormikForm
